import qs from "qs";

const options = qs.parse(window.location.search.slice(1));

const initialState = {
  activeFeatureName: options.region, // When you've clicked on a region (or circle in a region)
  hoveredFeature: undefined,
  searchBarVisible: false,
  searchedLocation: null, //Don't need this. (No address search)
  activePage: "map", // Not relevant? There was a table view before.
  basemap: "ROADMAP",
  activeProject: undefined, // This will be activeBusiness. And instead of popup, we have sidebar
  viewingHub: undefined, //Not used!
  mapType: "regions",
  internal: false,
  zoomToNsw: Date.now(), // hack that lets you zoom to NSW based on state
  sidebarScrollup: Date.now(),
  sidebarIsOpen: window.innerWidth >= 800,
};
export default (state = initialState, action) => {
  switch (action.type) {
    case "ACTIVE_FEATURE:SET":
      return {
        ...state,
        searchedLocation: null,
        activeFeatureName: action.payload,
      };
    case "HOVERED_FEATURE:SET":
      return {
        ...state,
        hoveredFeature: action.payload,
      };
    case "SEARCH_BAR_VISIBLE:SET":
      return { ...state, searchBarVisible: action.payload };
    case "SEARCHED_LOCATION:SET":
      return { ...state, searchedLocation: action.payload };
    case "ACTIVE_PROJECT:SET":
      return { ...state, activeProject: action.payload };
    case "ACTIVE_PAGE:SET": {
      return { ...state, activePage: action.payload };
    }
    case "MAP_TYPE:SET": {
      return { ...state, mapType: action.payload };
    }
    case "MAP:SET_BASEMAP": {
      return { ...state, basemap: action.payload };
    }
    case "ZOOM_TO_NSW": {
      return { ...state, zoomToNsw: action.payload };
    }
    case "SIDEBAR:OPEN": {
      return { ...state, sidebarIsOpen: action.payload };
    }
    case "SIDEBAR:SCROLLUP": {
      return { ...state, sidebarScrollup: action.payload };
    }

    default:
      return state;
  }
};

export const selectActiveFeatureName = (s) => s.activeFeatureName;
export const selectHoveredFeature = (s) => s.hoveredFeature;
export const selectSearchBarVisible = (s) => s.searchBarVisible;
export const selectSearchedLocation = (s) => s.searchedLocation;
export const selectActiveProject = (s) => s.activeProject;
export const selectActivePage = (s) => s.activePage;
export const selectMapType = (s) => s.mapType;
export const selectViewingHub = (s) => s.viewingHub;
export const selectIsInternal = (s) => s.internal;
export const selectBasemap = (s) => s.basemap;
export const selectZoomToNsw = (s) => s.zoomToNsw;
export const selectSidebarIsOpen = (s) => s.sidebarIsOpen;
export const selectSidebarScrollup = (s) => s.sidebarScrollup;



// WEBPACK FOOTER //
// ./src/reducers/ui.js